/* eslint-disable vue/no-template-key */
/* eslint-disable vue/no-template-key */
/* eslint-disable vue/no-template-key */
<template>
  <sidenav :orientation="orientation" :class="curClasses">

    <!-- Brand demo (see src/demo.css) -->
    <div class="app-brand demo" v-if="orientation !== 'horizontal'">
      <span class="app-brand-logo demo bg-primary">
        <svg viewBox="0 0 148 80" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><linearGradient id="a" x1="46.49" x2="62.46" y1="53.39" y2="48.2" gradientUnits="userSpaceOnUse"><stop stop-opacity=".25" offset="0"></stop><stop stop-opacity=".1" offset=".3"></stop><stop stop-opacity="0" offset=".9"></stop></linearGradient><linearGradient id="e" x1="76.9" x2="92.64" y1="26.38" y2="31.49" xlink:href="#a"></linearGradient><linearGradient id="d" x1="107.12" x2="122.74" y1="53.41" y2="48.33" xlink:href="#a"></linearGradient></defs><path style="fill: #fff;" transform="translate(-.1)" d="M121.36,0,104.42,45.08,88.71,3.28A5.09,5.09,0,0,0,83.93,0H64.27A5.09,5.09,0,0,0,59.5,3.28L43.79,45.08,26.85,0H.1L29.43,76.74A5.09,5.09,0,0,0,34.19,80H53.39a5.09,5.09,0,0,0,4.77-3.26L74.1,35l16,41.74A5.09,5.09,0,0,0,94.82,80h18.95a5.09,5.09,0,0,0,4.76-3.24L148.1,0Z"></path><path transform="translate(-.1)" d="M52.19,22.73l-8.4,22.35L56.51,78.94a5,5,0,0,0,1.64-2.19l7.34-19.2Z" fill="url(#a)"></path><path transform="translate(-.1)" d="M95.73,22l-7-18.69a5,5,0,0,0-1.64-2.21L74.1,35l8.33,21.79Z" fill="url(#e)"></path><path transform="translate(-.1)" d="M112.73,23l-8.31,22.12,12.66,33.7a5,5,0,0,0,1.45-2l7.3-18.93Z" fill="url(#d)"></path></svg>
      </span>
      <router-link to="/" class="app-brand-text demo sidenav-text font-weight-normal ml-2">QSNG</router-link>
      <a href="javascript:void(0)" class="layout-sidenav-toggle sidenav-link text-large ml-auto" @click="toggleSidenav()">
        <i class="ion ion-md-menu align-middle"></i>
      </a>
    </div>
    <div class="sidenav-divider mt-0" v-if="orientation !== 'horizontal'"></div>

    <!-- Links -->
    <div class="sidenav-inner" :class="{ 'py-1': orientation !== 'horizontal' }">
      <sidenav-header class="small font-weight-semibold">MENU MANAGEMENT</sidenav-header>

      <sidenav-menu :icon="item.ico" v-for="(item,index) in menuData.filter(obj => {return obj.pId === '0'})" :key="'0'+index" :active="isMenuActive('/'+item.code)" :open="isMenuOpen('/'+item.code)">
        <template slot="link-text" v-if="item.pId === '0' && item.link === '#'">{{item.name}}</template>
        <sidenav-menu :active="isMenuActive('/'+it.code)" :open="isMenuOpen('/'+it.code)" v-for="(it,index) in menuData.filter(obj => {return obj.pId === item.id && obj.link === '#'})" :key="'1'+index">
          <template slot="link-text" v-if="it.pId === item.id">{{it.name}}</template>
          <sidenav-router-link :to="'/'+i.link"  v-for="(i,index) in menuData.filter(obj => {return obj.pId === it.id})" :key="'2'+index">{{i.name}}</sidenav-router-link>
        </sidenav-menu>
        <sidenav-router-link  v-for="(t,index) in menuData.filter(obj => {return obj.pId === item.id && obj.link !== '#'})" :key="'3'+index" :to="'/'+t.link" :exact="true">{{t.name}}</sidenav-router-link>
      </sidenav-menu>
      <sidenav-divider class="mb-1"/>
      <sidenav-header class="small font-weight-semibold">HELP</sidenav-header>
      <sidenav-router-link to="/Center/Version" :exact="true" icon="ion ion-md-paper-plane">版本更新日志</sidenav-router-link>
      <sidenav-router-link to="/Assist/Document" :exact="true" icon="ion ion-md-help-circle">教程文档</sidenav-router-link>

    </div>
  </sidenav>
</template>

<script>
import { Sidenav, SidenavLink, SidenavRouterLink, SidenavMenu, SidenavHeader, SidenavBlock, SidenavDivider } from '@/vendor/libs/sidenav'

export default {
  name: 'app-layout-sidenav',
  data: () => ({
    menuData: [{ id: '', pId: '', menuType: '', name: '', ico: '', link: '', menuId: '', sort: 1, valid: '' }]
  }),
  components: {
    /* eslint-disable vue/no-unused-components */
    Sidenav,
    SidenavLink,
    SidenavRouterLink,
    SidenavMenu,
    SidenavHeader,
    SidenavBlock,
    SidenavDivider
    /* eslint-enable vue/no-unused-components */
  },
  props: {
    orientation: {
      type: String,
      default: 'vertical'
    }
  },

  computed: {
    curClasses () {
      let bg = this.layoutSidenavBg

      if (this.orientation === 'horizontal' && (bg.indexOf(' sidenav-dark') !== -1 || bg.indexOf(' sidenav-light') !== -1)) {
        bg = bg
          .replace(' sidenav-dark', '')
          .replace(' sidenav-light', '')
          .replace('-darker', '')
          .replace('-dark', '')
      }

      return `bg-${bg} ` + (
        this.orientation !== 'horizontal'
          ? 'layout-sidenav'
          : 'layout-sidenav-horizontal container-p-x flex-grow-0'
      )
    }
  },
  created () {
    this.menu()
  },

  methods: {
    isMenuActive (url) {
      return this.$route.path.indexOf(url) === 0
    },

    isMenuOpen (url) {
      return this.$route.path.indexOf(url) === 0 && this.orientation !== 'horizontal'
    },

    toggleSidenav () {
      this.layoutHelpers.toggleCollapsed()
    },
    // 菜单绑定
    menu: function () {
      const data = {
        tel: this.tel,
        password: this.password
      }
      this.$axios.fetchPost('/Center/Menu', data).then((result) => {
        if (result.status === 200) {
          const res = result.data
          if (res.success) {
            this.menuData = res.data
          } else {
            this.$router.push({ path: '/Assist/Login' })
          }
        } else if (result.status === 401) {
          this.$router.push({ path: '/Assist/Login' })
        } else {
        }
      }).catch(error => {
        console.log(error)
        this.$router.push({ path: '/Assist/Login' })
      })
    }
  }
}
</script>
